import { render, staticRenderFns } from "./LazyLoading.vue?vue&type=template&id=7996f88f&scoped=true&"
import script from "./LazyLoading.vue?vue&type=script&lang=js&"
export * from "./LazyLoading.vue?vue&type=script&lang=js&"
import style0 from "./LazyLoading.vue?vue&type=style&index=0&id=7996f88f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7996f88f",
  null
  
)

component.options.__file = "LazyLoading.vue"
export default component.exports